<template>
  <o-button
    :to="to ? to : null"
    :label="label ? label : 'Betalen'"
    :is-primary="!dangerous && !secondary"
    :is-floating="true"
    :is-secondary="secondary"
    :is-dangerous="dangerous"
    @click="$emit('click')"
  />
</template>

<script>
export default {
  name: 'OPayButton',
  props: {
    to: String | Object,
    label: {
      type: String,
      default: null
    },
    dangerous: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    }
  }
}
</script>
